import {useState} from 'react';

export const AVAILABLE_LIMITS = [10, 50, 100];
export const DEFAULT_LIMIT = AVAILABLE_LIMITS[0];

interface States {
  limit: number;
  offset: number;
}
interface Actions {
  setLimit: (limit: number) => void;
  setOffset: (offset: number) => void;
}
export default function useLimitOffset(): [States, Actions] {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const setLimitResetOffset = (newLimit: number): void => {
    if (limit !== newLimit) {
      setOffset(0);
    }
    setLimit(newLimit);
  };
  return [
    {limit, offset},
    {setLimit: setLimitResetOffset, setOffset},
  ];
}
